/****
 * { tabsItem } tabs dom
 * tabs变成固定定位 
  * 
 */
function setTabsToFixed(
    tabsItem,
    navHeaderBox = document.querySelector('.header--top-left'),
    initialTabsItemHeight = '',
    fixedStyles = `
        position: fixed;
        top: 0;
        width: 100%;
        background-color: #fff;
        padding: 0;
        z-index: 10000;
    `
) {
    // 用局部变量保持高度状态
    let tabsItemHeight = initialTabsItemHeight;

    window.addEventListener('scroll', function () {
        // 更新逻辑保持不变
        tabsItemHeight = tabsItem.offsetTop != 0 && tabsItem.offsetTop != tabsItemHeight
            ? tabsItem.offsetTop
            : tabsItemHeight;

        const scrollDistance = window.scrollY || document.documentElement.scrollTop;

        if (scrollDistance >= tabsItemHeight) {
            tabsItem.style.cssText = fixedStyles;
            navHeaderBox.style.display = 'none'; // 使用参数传入的navHeaderBox
        } else {
            tabsItem.style.position = 'relative';
            navHeaderBox.style.display = 'unset';
        }
    });
}
/***
 * 节流
 */
function throttle(callback, delay) {
    let last;
    let timer;
    return function () {
        const now = Date.now();
        if (last && now < last + delay) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                last = now;
                callback();
            }, delay);
        } else {
            last = now;
            callback();
        }
    };
}
/***
 * 防抖
 */
function debounce(func, wait) {
    let timeout;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}